module.exports = __webpack_public_path__ + "img/marking-classified-information.cf4c7129.png";